import { apiClient } from './api'

export interface ProjectApprovalGate {
  id: number
  project_id: number
  gate_number: string
  name: string
  status: string
  progress: number
  due_date: string | null
  completed_date: string | null
  approver: string | null
  documents_total: number
  documents_completed: number
  decisions_total: number
  decisions_approved: number
  risk_status: string | null
  position: number
}

export interface ProjectApprovalGateCreate {
  gate_number: string
  name: string
  status?: string
  progress?: number
  due_date?: string | null
  completed_date?: string | null
  approver?: string | null
  documents_total?: number
  documents_completed?: number
  decisions_total?: number
  decisions_approved?: number
  risk_status?: string | null
  position?: number
}

export const projectApprovalGatesService = {
  list(projectId: number): Promise<ProjectApprovalGate[]> {
    return apiClient.get(`/api/v1/projects/${projectId}/gates/`).then((r) => r.data)
  },
  get(projectId: number, gateId: number): Promise<ProjectApprovalGate> {
    return apiClient.get(`/api/v1/projects/${projectId}/gates/${gateId}`).then((r) => r.data)
  },
  create(projectId: number, body: ProjectApprovalGateCreate): Promise<ProjectApprovalGate> {
    return apiClient.post(`/api/v1/projects/${projectId}/gates/`, body).then((r) => r.data)
  },
  update(projectId: number, gateId: number, body: Partial<ProjectApprovalGateCreate>): Promise<ProjectApprovalGate> {
    return apiClient.patch(`/api/v1/projects/${projectId}/gates/${gateId}`, body).then((r) => r.data)
  },
  delete(projectId: number, gateId: number): Promise<void> {
    return apiClient.delete(`/api/v1/projects/${projectId}/gates/${gateId}`)
  },
}

/** Map API gate to UI shape (documents/decisions as objects). */
export function gateToUiShape(g: ProjectApprovalGate) {
  return {
    id: g.id,
    number: g.gate_number,
    name: g.name,
    status: g.status,
    progress: g.progress,
    dueDate: g.due_date ?? null,
    completedDate: g.completed_date ?? null,
    approver: g.approver ?? '',
    documents: { total: g.documents_total, completed: g.documents_completed },
    decisions: { total: g.decisions_total, approved: g.decisions_approved },
    riskStatus: g.risk_status ?? 'on-track',
  }
}
